import { API, Auth } from 'aws-amplify';

const apiName = 'AdminQueries';

export async function buildHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
  };
}

export async function createUser(email, givenName, familyName) {
  const path = '/createUser';
  const myInit = {
    body: {
      email,
      givenName,
      familyName,
    },
    headers: await buildHeaders(),
  };

  return API.post(apiName, path, myInit);
}

export async function getUser(username) {
  const path = '/getUser';
  const myInit = {
    queryStringParameters: {
      username,
    },
    headers: await buildHeaders(),
  };

  return API.get(apiName, path, myInit);
}

export async function getUsers(usernames) {
  const path = '/getUsers';
  const myInit = {
    body: {
      usernames,
    },
    headers: await buildHeaders(),
  };

  return API.post(apiName, path, myInit);
}

export async function getUserGroups(username) {
  const path = '/listGroupsForUser';
  const myInit = {
    queryStringParameters: {
      username,
    },
    headers: await buildHeaders(),
  };

  return API.get(apiName, path, myInit);
}

export async function updateUserAttributes(username, attributes) {
  const path = '/updateUserAttributes';
  const myInit = {
    body: {
      username,
      attributes,
    },
    headers: await buildHeaders(),
  };

  return API.post(apiName, path, myInit);
}

export async function disableUser(username) {
  const path = '/disableUser';
  const myInit = {
    body: {
      username,
    },
    headers: await buildHeaders(),
  };

  return API.post(apiName, path, myInit);
}
